import { useListRecordsQuery } from '@platform/state/api';
import type { IRecord, IRecordTypeDefinition } from '@platform/core/types';
import { selfParentFieldOf } from './childRelations';

/**
 * Дочірні записи ієрархії (прототип «Дочірні завдання»): записи того самого типу з полем-батьком = цей запис (до 100, за кодом).
 * Той самий запит використовують вкладка й лічильник у її заголовку (спільний кеш RTK Query).
 */
export function useChildRecords(ws: string, rt: IRecordTypeDefinition, record: IRecord) {
  const parent = selfParentFieldOf(rt);
  const query = useListRecordsQuery(
    { ws, rt: rt.key, params: { filter: `${parent?.key ?? 'parent'}:eq:${record.id}`, pageSize: 100, sort: 'code' } },
    { skip: !parent || !record.id },
  );
  return { parent, items: query.data?.items ?? [], total: query.data?.total ?? 0, isLoading: query.isLoading, error: query.error };
}
